import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  actions,
  mutations,
  // plugins: [createPersistedState()],
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })],
  getters: {
    isAuthenticated: state => !!state.token,
    loginError (state) {
      return state.loginError
    },
    token (state) {
      return state.token
    },
    roleSelected (state) {
      return state.roleSelected
    },
    dynamics (state) {
      return state.dynamics
    },
    noDynamics (state) {
      return state.noDynamics
    },
    roleID (state) {
      return state.roleID
    },
    firstname (state) {
      if (state.firstname !== 'null') {
        return state.firstname.charAt(0).toUpperCase() + state.firstname.slice(1)
      }
    },
    lastname (state) {
      if (state.lastname !== 'null') {
        return state.lastname.charAt(0).toUpperCase() + state.lastname.slice(1)
      }
    },
    upDated (state) {
      return state.updated
    },
    installsDonut (state) {
      return state.installsDonut.values
    },
    donutsData (state) {
      return state.donutsData.values
    },
    alldonutsData (state) {
      return state.alldonutsData.values
    },
    firstTenant (state) {
      return state.firstTenant
    },
    tenantsList (state) {
      return state.tenantsList
    },
    tenantsGroupList (state) {
      return state.tenantsGroupList
    },
    currentDevice (state) {
      return state.currentDevice.values
    },
    secretKey (state) {
      return state.secretKey
    },
    username (state) {
      return state.username
    },
    loginUsername (state) {
      return state.loginUsername
    },
    password (state) {
      return state.password
    },
    otp (state) {
      return state.otp
    },
    otpauth (state) {
      return state.otpauth
    },
    selecta () {
      return state.selecta
    },
    valueK0 (state) {
      return state.k0
    },
    valueK1 (state) {
      return state.k1
    },
    valueK2 (state) {
      return state.k2
    },
    valueK3 (state) {
      return state.k3
    },
    valueK4 (state) {
      return state.k4
    },
    valueK5 (state) {
      return state.k5
    },
    valueK6 (state) {
      return state.k6
    },
    valueK7 (state) {
      return state.k7
    },
    valueK8 (state) {
      return state.k8
    },
    valueK9 (state) {
      return state.k9
    },
    valueK10 (state) {
      return state.k10
    },
    valueK11 (state) {
      return state.k11
    },
    valueK12 (state) {
      return state.k12
    },
    valueK13 (state) {
      return state.k13
    },
    totalAlert (state) {
      return Math.round(parseInt(state.k13) + parseInt(state.k1) + parseInt(state.k12) + parseInt(state.k11))
    },
    Installed (state) {
      return state.Installed
    },
    LeakActive (state) {
      return state.LeakActive
    },
    LeakInactive (state) {
      return state.LeakInactive
    },
    Learning (state) {
      return state.Learning
    },
    Other (state) {
      return Math.round(parseInt(state.Installed) - (parseInt(state.LeakActive) + parseInt(state.LeakInactive) + parseInt(state.Learning)))
    },
    leakActivePercentage (state) {
      return Math.round(parseInt(state.LeakActive) / (parseInt(state.LeakActive) + parseInt(state.LeakInactive) + parseInt(state.Learning) + (parseInt(state.Installed) - (parseInt(state.LeakActive) + parseInt(state.LeakInactive) + parseInt(state.Learning))))) * 100
    },
    leakInactivePercentage (state) {
      return Math.round(parseInt(state.LeakInactive) / (parseInt(state.LeakActive) + parseInt(state.LeakInactive) + parseInt(state.Learning) + (parseInt(state.Installed) - (parseInt(state.LeakActive) + parseInt(state.LeakInactive) + parseInt(state.Learning))))) * 100
    },
    learningPercentage (state) {
      return Math.round(parseInt(state.Learning) / (parseInt(state.LeakActive) + parseInt(state.LeakInactive) + parseInt(state.Learning) + (parseInt(state.Installed) - (parseInt(state.LeakActive) + parseInt(state.LeakInactive) + parseInt(state.Learning))))) * 100
    },
    otherPercentage (state) {
      return Math.round((parseInt(state.Installed) - (parseInt(state.LeakActive) + parseInt(state.LeakInactive) + parseInt(state.Learning))) / (parseInt(state.LeakActive) + parseInt(state.LeakInactive) + parseInt(state.Learning) + (parseInt(state.Installed) - (parseInt(state.LeakActive) + parseInt(state.LeakInactive) + parseInt(state.Learning))))) * 100
    },
    leakFreeNeverHadALeakPercentage (state) {
      return Math.round(parseInt(state.k13) / (parseInt(state.k13) + parseInt(state.k1) + parseInt(state.k12) + parseInt(state.k11)) * 100)
    },
    leakFreeHadALeakInPastPercentage (state) {
      return Math.round(parseInt(state.k1) / (parseInt(state.k13) + parseInt(state.k1) + parseInt(state.k12) + parseInt(state.k11)) * 100)
    },
    leakDetectedFirstPercentage (state) {
      return Math.round(parseInt(state.k12) / (parseInt(state.k13) + parseInt(state.k1) + parseInt(state.k12) + parseInt(state.k11)) * 100)
    },
    leakDetectedSecondPercentage (state) {
      return Math.round(parseInt(state.k11) / (parseInt(state.k13) + parseInt(state.k1) + parseInt(state.k12) + parseInt(state.k11)) * 100)
    },
    valueSignal_1 (state) {
      if (state.k4 !== '0') {
        return Math.round(((parseInt(state.k4) - parseInt(state.k10)) / parseInt(state.k4)) * 100)
      } else {
        return 0
      }
    },
    valueSignal_2 (state) {
      return Math.round(parseInt(state.k4) - parseInt(state.k10))
    },
    valueNoSignal_1 (state) {
      if (state.k4 !== '0') {
        return Math.round((parseInt(state.k10) / parseInt(state.k4)) * 100)
      } else {
        return 0
      }
    },
    valueNoSignal_2 (state) {
      return Math.round(parseInt(state.k10))
    },
    valuePNHL_2 (state) {
      return Math.round(parseInt(state.k4) - (parseInt(state.k5) + parseInt(state.k1)))
    },
    valuePNHL_1 (state) {
      if (state.k4 !== '0') {
        return Math.round(((parseInt(state.k4) - (parseInt(state.k5) + parseInt(state.k1))) / parseInt(state.k4)) * 100)
      } else {
        return 0
      }
    },
    valuePWL_1 (state) {
      if (state.k4 !== '0') {
        return Math.round((state.k5 / state.k4) * 100)
      } else {
        return 0
      }
    },
    valueHALP_1 (state) {
      if (state.k4 !== '0') {
        return Math.round((parseInt(state.k1) / parseInt(state.k4)) * 100)
      } else {
        return 0
      }
    },
    valuePLF (state) {
      if (state.k4 !== '0') {
        return Math.round(((parseInt(state.k4) - parseInt(state.k5)) / parseInt(state.k4)) * 100)
      } else {
        return 0
      }
    },
    valueLGA_1 (state) {
      if (state.k1 !== '0') {
        return Math.round(((parseInt(state.k1) - (parseInt(state.k8) + parseInt(state.k9))) / parseInt(state.k1)) * 100)
      } else {
        return 0
      }
    },
    valueLGA_2 (state) {
      return Math.round(parseInt(state.k1) - (parseInt(state.k8) + parseInt(state.k9)))
    },
    valueCRA (state) { // same as valueCRA1
      if (state.k1 !== '0') {
        return Math.round((parseInt(state.k8) / parseInt(state.k1)) * 100)
      } else {
        return 0
      }
    },
    valueCCSF (state) {
      if (state.k1 !== '0') {
        return Math.round((parseInt(state.k9) / parseInt(state.k1)) * 100)
      } else {
        return 0
      }
    },
    valueUBC_1 (state) { // same as ULBC
      if (state.k5 !== '0') {
        return Math.round((parseInt(state.k3) / parseInt(state.k5)) * 100)
      } else {
        return 0
      }
    },
    valueDAH_1 (state) {
      if (state.k5 !== '0') {
        return Math.round((parseInt(state.k2) / parseInt(state.k5)) * 100)
      } else {
        return 0
      }
    },
    valueDAM_1 (state) {
      if (state.k5 !== '0') {
        return Math.round((parseInt(state.k7) / parseInt(state.k5)) * 100)
      } else {
        return 0
      }
    },
    // Auth0 getters
    auth0Client (state) {
      return state.auth0Client
    },
    auth0IsLoading (state) {
      return state.auth0IsLoading
    },
    auth0IsAuthenticated (state) {
      return state.auth0IsAuthenticated
    },
    auth0User (state) {
      return state.auth0User
    },
    auth0Error (state) {
      return state.auth0Error
    }
  }
})
